import styled from 'styled-components';

export const ManageLoanDrawerStyles = styled.div`
	height: 100%;

	.prices {
		margin: 0.5rem 0 1rem;
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
		border-radius: 0.25rem;
		padding: 0.5rem;
		background: ${({ theme }) => theme.v3.colors.gray[0]};
	}

	.structure {
		border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
		border-radius: 0.5rem;

		&-head {
			border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
			padding: 0.5rem;
		}

		&-body {
			padding: 1rem;
		}
	}

	.cash-balance {
		border-radius: 0.25rem;
		padding: 0.5rem;
		background: ${({ theme }) => theme.v3.colors.dark[4]};
	}
`;
